import { render, staticRenderFns } from "./RobotAssistant.vue?vue&type=template&id=d08fe5d4&scoped=true"
import script from "./RobotAssistant.vue?vue&type=script&lang=js"
export * from "./RobotAssistant.vue?vue&type=script&lang=js"
import style0 from "./RobotAssistant.vue?vue&type=style&index=0&id=d08fe5d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d08fe5d4",
  null
  
)

export default component.exports